(function () {
  var DIALOG_ID = 'ciw-la-exit-confirm';
  var TITLE_ID = 'ciw-la-exit-confirm-title';
  var DIALOG_VERSION = '6';
  var CLOSE_ANIM_MS = 220;
  var USAGE_STEP_SELECTOR =
    window.ciwLaUsageStepSelector ||
    '.la-choose-prescription-wrapper:not(.la-render-lenses):not(.la-render-options):not(.la-render-review)';

  var LENS_STEP_SELECTORS = [
    '.la-choose-prescription-wrapper.la-render-lenses',
    '.la-choose-prescription-wrapper.la-render-options',
    '.la-choose-prescription-wrapper.la-render-addons',
    '.la-choose-prescription-wrapper.la-render-review',
    '.la-choose-prescription-wrapper.ciw-la-lens-thickness-step',
    '.la-choose-prescription-wrapper.ciw-la-lens-color-step',
    '.ciw-la-lens-thickness-step',
    '.ciw-la-lens-color-step'
  ];

  var dialogEl = null;
  var previousFocus = null;
  var dialogMode = 'exit';
  var currentOptions = {};

  var EXIT_DEFAULTS = {
    title: 'Leave without saving?',
    text: "Your lens selections won't be saved if you exit now.",
    primaryLabel: 'No, Continue',
    secondaryLabel: 'Yes, Exit',
    hideSecondary: false
  };

  function isLensReplacementLaFlow() {
    return (
      document.body.classList.contains('template-product-lens-replacement-stub') ||
      !!document.querySelector('.ciw-pdp--lens-replacement')
    );
  }

  function isEyeglassLaFlow() {
    if (window.ciwLaHostApi) {
      return window.ciwLaHostApi.isEyeglass() && !window.ciwLaHostApi.isContactLens();
    }
    return !!document.querySelector('.ciw-pdp') && !document.querySelector('.cl-section');
  }

  function isVisibleInModal(el) {
    if (!el || el.hasAttribute('hidden')) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return el.getClientRects().length > 0;
  }

  function isUploadRxStep() {
    var form = document.querySelector('#la-prescription-form');
    return !!(form && form.classList.contains('ciw-la-upload-rx-form--mobile'));
  }

  function isManualEntryStep() {
    if (isUploadRxStep()) return false;
    var form = document.querySelector('#la-prescription-form');
    if (!form) return false;
    return !!(
      form.querySelector('.la-right-rx-container') &&
      form.querySelector('.la-left-rx-container')
    );
  }

  function isPrescriptionTypeStep() {
    if (isManualEntryStep()) return false;
    var usageStep = document.querySelector(USAGE_STEP_SELECTOR);
    return !!(usageStep && isVisibleInModal(usageStep));
  }

  function isSubmissionMethodStep() {
    var wrapper = document.querySelector('.la-prescription-wrapper:not(form)');
    if (wrapper && isVisibleInModal(wrapper)) return true;
    var submissionMethod = document.querySelector('.la-label-btn-wrapper.la-submission-method');
    return !!(submissionMethod && isVisibleInModal(submissionMethod));
  }

  function isLensSelectionStep() {
    for (var i = 0; i < LENS_STEP_SELECTORS.length; i++) {
      var el = document.querySelector(LENS_STEP_SELECTORS[i]);
      if (el && isVisibleInModal(el)) return true;
    }
    return false;
  }

  function shouldConfirmLensExit() {
    if (!document.body.classList.contains('la-modal-open')) return false;
    if (!isEyeglassLaFlow()) return false;
    if (isLensReplacementLaFlow()) return false;
    if (isPrescriptionTypeStep()) return false;
    if (isSubmissionMethodStep()) return false;
    if (isManualEntryStep()) return false;
    if (isUploadRxStep()) return false;
    return isLensSelectionStep();
  }

  function destroyDialog() {
    if (!dialogEl) return;
    dialogEl.remove();
    dialogEl = null;
  }

  function ensureDialog() {
    if (dialogEl && dialogEl.getAttribute('data-ciw-la-exit-version') !== DIALOG_VERSION) {
      destroyDialog();
    }
    if (dialogEl) return dialogEl;

    dialogEl = document.createElement('div');
    dialogEl.id = DIALOG_ID;
    dialogEl.className = 'ciw-la-exit-confirm';
    dialogEl.setAttribute('data-ciw-la-exit-version', DIALOG_VERSION);
    dialogEl.setAttribute('hidden', 'hidden');
    dialogEl.setAttribute('aria-hidden', 'true');
    dialogEl.innerHTML =
      '<div class="ciw-la-exit-confirm__dialog" role="dialog" aria-modal="true" aria-labelledby="' +
      TITLE_ID +
      '" tabindex="-1">' +
      '<div class="ciw-la-exit-confirm__header">' +
      '<p id="' +
      TITLE_ID +
      '" class="ciw-la-exit-confirm__title">Leave without saving?</p>' +
      '<button type="button" class="ciw-la-exit-confirm__header-close" data-ciw-la-exit-dismiss aria-label="Close">' +
      '<svg width="15" height="15" viewBox="0 0 15 15" aria-hidden="true" focusable="false">' +
      '<path d="M1 1l13 13M14 1L1 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path>' +
      '</svg>' +
      '</button>' +
      '</div>' +
      '<div class="ciw-la-exit-confirm__body">' +
      '<p class="ciw-la-exit-confirm__text">Your lens selections won\'t be saved if you exit now.</p>' +
      '</div>' +
      '<div class="ciw-la-exit-confirm__actions">' +
      '<button type="button" class="ciw-la-exit-confirm__btn ciw-la-exit-confirm__btn--continue" data-ciw-la-exit-continue>No, Continue</button>' +
      '<button type="button" class="ciw-la-exit-confirm__btn ciw-la-exit-confirm__btn--exit" data-ciw-la-exit-confirm>Yes, Exit</button>' +
      '</div>' +
      '</div>';

    dialogEl.querySelector('[data-ciw-la-exit-dismiss]').addEventListener('click', onDismiss);
    dialogEl.querySelector('[data-ciw-la-exit-continue]').addEventListener('click', onPrimaryClick);
    dialogEl.querySelector('[data-ciw-la-exit-confirm]').addEventListener('click', onSecondaryClick);
    dialogEl.addEventListener('click', function (event) {
      if (event.target === dialogEl) hideDialog();
    });

    document.body.appendChild(dialogEl);
    return dialogEl;
  }

  function isDialogOpen() {
    return !!(
      dialogEl &&
      (dialogEl.classList.contains('is-open') || dialogEl.classList.contains('is-closing'))
    );
  }

  function hideDialog() {
    if (!dialogEl || !dialogEl.classList.contains('is-open')) return;

    dialogEl.classList.remove('is-open');
    dialogEl.classList.add('is-closing');
    dialogEl.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ciw-la-exit-confirm-open');

    window.setTimeout(function () {
      if (!dialogEl) return;
      dialogEl.classList.remove('is-closing');
      dialogEl.setAttribute('hidden', 'hidden');

      if (previousFocus && typeof previousFocus.focus === 'function') {
        previousFocus.focus();
      }
      previousFocus = null;
    }, CLOSE_ANIM_MS);
  }

  function closeLaModal() {
    document.dispatchEvent(new CustomEvent('LensAdvizor:selectLensModal:close'));
  }

  function confirmExit() {
    hideDialog();
    closeLaModal();
  }

  function applyDialogContent(options) {
    options = options || {};
    var title = options.title != null ? options.title : EXIT_DEFAULTS.title;
    var text = options.text != null ? options.text : EXIT_DEFAULTS.text;
    var primaryLabel =
      options.primaryLabel != null ? options.primaryLabel : EXIT_DEFAULTS.primaryLabel;
    var secondaryLabel =
      options.secondaryLabel != null ? options.secondaryLabel : EXIT_DEFAULTS.secondaryLabel;
    var hideSecondary = !!options.hideSecondary;

    dialogEl.querySelector('.ciw-la-exit-confirm__title').textContent = title;
    dialogEl.querySelector('.ciw-la-exit-confirm__text').textContent = text;

    var bodyEl = dialogEl.querySelector('.ciw-la-exit-confirm__body');
    if (text) {
      bodyEl.style.display = '';
    } else {
      bodyEl.style.display = 'none';
    }

    var primaryBtn = dialogEl.querySelector('[data-ciw-la-exit-continue]');
    var secondaryBtn = dialogEl.querySelector('[data-ciw-la-exit-confirm]');
    primaryBtn.textContent = primaryLabel;
    secondaryBtn.textContent = secondaryLabel;
    secondaryBtn.style.display = hideSecondary ? 'none' : '';
  }

  function onDismiss() {
    hideDialog();
  }

  function onPrimaryClick() {
    if (dialogMode === 'exit') {
      hideDialog();
      return;
    }
    if (typeof currentOptions.onPrimary === 'function') {
      currentOptions.onPrimary();
    }
    hideDialog();
  }

  function onSecondaryClick() {
    if (dialogMode === 'exit') {
      confirmExit();
      return;
    }
    if (typeof currentOptions.onSecondary === 'function') {
      currentOptions.onSecondary();
    }
    hideDialog();
  }

  function showDialog(options) {
    var dialog = ensureDialog();
    if (dialog.parentElement !== document.body) {
      document.body.appendChild(dialog);
    }

    if (options && typeof options === 'object') {
      dialogMode = 'custom';
      currentOptions = options;
      applyDialogContent(options);
    } else {
      dialogMode = 'exit';
      currentOptions = {};
      applyDialogContent(EXIT_DEFAULTS);
    }

    previousFocus = document.activeElement;
    dialog.classList.remove('is-closing');
    dialog.removeAttribute('hidden');
    dialog.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ciw-la-exit-confirm-open');

    void dialog.offsetWidth;
    dialog.classList.add('is-open');

    var primaryBtn = dialog.querySelector('[data-ciw-la-exit-continue]');
    if (primaryBtn) primaryBtn.focus();
  }

  function onKeyDown(event) {
    if (!isDialogOpen()) return;
    if (event.key !== 'Escape') return;
    event.preventDefault();
    event.stopPropagation();
    hideDialog();
  }

  function onCloseClick(event) {
    if (!document.body.classList.contains('la-modal-open')) return;
    if (!event.target.closest('.la-prescription-modal-close')) return;

    if (isDialogOpen()) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      if (dialogEl.classList.contains('is-open')) {
        hideDialog();
      }
      return;
    }

    if (!shouldConfirmLensExit()) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    showDialog();
  }

  function bind() {
    if (!document.querySelector('.ciw-pdp')) return;

    document.addEventListener('click', onCloseClick, true);
    document.addEventListener('keydown', onKeyDown, true);
    document.addEventListener('LensAdvizor:selectLensModal:close', hideDialog);
  }

  window.ciwLaConfirmDialog = {
    show: showDialog,
    hide: hideDialog,
    isOpen: isDialogOpen
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
